import { CasingComparisonClient } from "./CasingComparisonClient";

export default function CasingPage() {
  return <CasingComparisonClient />;
}
